import { Chain, DEFAULT_SUPPORTED_CHAINS } from "@usedapp/core";
import { KCCChain, KCCChain_Test, KccIcon } from "@/chain-info/KCCChain";
import { ZetaChain_Test } from "@/chain-info/ZetaChain";

DEFAULT_SUPPORTED_CHAINS.forEach((chain) => {
  if (chain.chainId === 324) {
    chain.getExplorerAddressLink = (address: string) => {
      return `https://explorer.zksync.io/address/${address}`;
    };
    chain.getExplorerTransactionLink = (hash: string) => {
      return `https://explorer.zksync.io/tx/${hash}`;
    };
  }
});

export const KARATDAO_DEFAULT_SUPPORTED_CHAINS: Chain[] = [
  ...DEFAULT_SUPPORTED_CHAINS,
  KCCChain,
  KCCChain_Test,
  ZetaChain_Test,
];
